<mat-toolbar class="h-9">
  <app-jkbtnedit #stkme001 label="群組" [showClearButton]="true" [required]="true"
  maintable="STKME" item="W01" valueExpr="ME001" displayExpr="ME002"
  (valueChange)="doQuery()"
  [(value)]="stockSrv.stkme001">
</app-jkbtnedit>
<app-jkcombobox #stklg002 labelMode="floating" label="資料頻率" [items]="stockSrv.stklg002List" displayExpr="name"
  valueExpr="id" [(value)]="stockSrv.stklg002" [styleDisplay]="'flex'">
  </app-jkcombobox>
  <button class="btn" [class.btn-primary]="true" (click)="doQuery()">
    <mat-icon fontIcon="search"></mat-icon>查詢
  </button>

  <mat-paginator #paginator [pageSizeOptions]="[5]" showFirstLastButtons
    aria-label="Select page of periodic elements">
  </mat-paginator>
  <app-titlebar #titlebar (backClick)="onBackClick()">
  </app-titlebar>
</mat-toolbar>
<table mat-table [dataSource]="dataSource">
  <!-- Name Column -->
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef> 代號 </th>
    <td mat-cell *matCellDef="let item" style="height: 12px;"><app-stock-view01 #view1 view1
        [data]="$safeNavigationMigration(item?.stockData)"></app-stock-view01>
    </td>
  </ng-container>
  <!-- <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef> 簡號 </th>
    <td mat-cell *matCellDef="let item" style="height: 12px;"> {{item.name}} </td>
  </ng-container> -->
  <ng-container matColumnDef="chart">
    <th mat-header-cell *matHeaderCellDef> chart </th>
    <td mat-cell *matCellDef="let item">
      <div style="width: 500px;">
        <app-line-chart [stockno]="item.id" [title]="item.name" [height]="150">
        </app-line-chart>
      </div>
    </td>
  </ng-container>

  <tr class="text-blue-800" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

